/* @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import CircularProgress from '@material-ui/core/CircularProgress';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './Loading.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

class Loading extends React.Component<*> {
  render(): React.Element<*> {
    const { variant, style }: any = this.props;
    const size: string = variant === 'small' ? styles.small : '';

    return (
      <div className={`${styles['loading-container']} ${size}`} style={style}>
        <CircularProgress className={styles['loading-animation']} />
      </div>
    );
  }
}

export default Loading;
